'use es6';

export const DRAFT_KEY_PREFIX = 'COMMON_REPLY_DRAFT';